import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

type DialogData = {
    title: string;
    message: string;
    continueBtnText?: string;
    cancelBtnText?: string;
};

@Component({
    selector: "app-user-consent-dialog",
    templateUrl: "./user-consent-dialog.component.html",
    styleUrls: ["./user-consent-dialog.component.scss"],
    standalone: true,
    imports: [MatDialogModule, MatButtonModule]
})
export class UserConsentDialogComponent implements OnInit {
    title: string;
    message: string;
    userResponse: boolean;
    continueBtnText = "Yes";
    cancelBtnText = "No";

    constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
        if (data) {
            this.title = data.title;
            this.message = data.message;
            this.continueBtnText = data.continueBtnText ?? "Yes";
            this.cancelBtnText = data.cancelBtnText ?? "No";
        }
    }

    ngOnInit(): void {}

    userResponseHandler(response: boolean) {
        this.userResponse = response;
    }
}
